import { render, staticRenderFns } from "./EventContainer.vue?vue&type=template&id=d22e6b9c&"
import script from "./EventContainer.vue?vue&type=script&lang=js&"
export * from "./EventContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports